import { Alert, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { CyOffline } from "./CyOffline";
import { useTranslation } from "react-i18next";

interface Props {
  startUpdate: () => void;
}

export function DownloadNecessaryNotification(props: Props) {
  const { t } = useTranslation();
  return (
    <Alert
      color="warning"
      fade={false}
      className="my-2 d-flex justify-content-center"
    >
      <Button
        color="primary"
        onClick={() => props.startUpdate()}
        data-cy={CyOffline.DownloadButton}
      >
        <FontAwesomeIcon icon={faBell} /> {t("offline.downloadNecessary")}
      </Button>
    </Alert>
  );
}
